// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__Q0Ky0","col":"styles_col__2vSoM"};